<template>
  <h1>{{ $t("instruction.header") }}
  </h1>
  <h6 style="color:blue;text-decoration: underline;cursor: pointer" @click="show()">{{ $t("instruction.how-to-play") }}</h6>

    <!-- Modal -->
    <div class="modal fade" id="instructionModal" tabindex="-1" aria-labelledby="instructionModalLabel" aria-hidden="true" >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger" id="instructionModalLabel">{{ $t("instruction.instruction") }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" :aria-label=" $t('common.close') "></button>
          </div>
          <div class="modal-body">
            <p class="text-start" v-html="$t('instruction.part1')"></p>
            <div>
              <input disabled value="E" class="input_exist"/>
              <input disabled value="L"/>
              <input disabled value="S" class="input_exist"/>
              <input disabled value="K" class="input_ok"/>
              <input disabled value="E"/>
              <input disabled value="R"  />
            </div>
            <p class="text-start mt-3" v-html="$t('instruction.part2')">
            </p>
            <div>
              <input disabled value="S" class="input_ok"/>
              <input disabled value="N" class="input_ok"/>
              <input disabled value="A" class="input_ok"/>
              <input disabled value="K" class="input_ok"/>
              <input disabled value="K" class="input_ok"/>
              <input disabled value="E"  class="input_ok"/>
            </div>
            <p class="text-start mt-3" v-html="$t('instruction.part3')"></p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal">{{ $t('common.close') }}</button>
          </div>
        </div>
      </div>

    </div>

</template>

<script>
import 'bootstrap/dist/css/bootstrap.min.css'
import "bootstrap-icons/font/bootstrap-icons.css";
import {Modal} from "bootstrap";
export default {
  name: "Instruction",
  data() {
    return {
      showModal: false,
      modalObj:null,
    }
  },
  mounted() {
    console.log(document.getElementById('exampleModal'));
    this.modalObj  = new Modal(document.getElementById('instructionModal'))
  },
  methods: {
    show() {
      this.modalObj.show();
    },
  },
}
</script>

<style scoped>

input.input_wrong{
  background-color: grey;
}
input.input_ok{
  background-color: lightgreen;
}
input.input_exist{
  background-color: orange;
}
input.input_notexist{
  background-color: red;
}
input {
  width: 40px;
  height: 50px;
  font-size: 18pt;
  text-align: center;
  text-transform: uppercase;
}
</style>